module.exports = __webpack_public_path__ + "img/trainer.b65d82c5.png";